import { render } from "./UiRadioCards.vue?vue&type=template&id=569e4fee"
import script from "./UiRadioCards.vue?vue&type=script&lang=js"
export * from "./UiRadioCards.vue?vue&type=script&lang=js"

import exportComponent from "/home/ubuntu/actions-runner/_work/frontend/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__